import {faCaretDown} from '@awesome.me/kit-d4c1b300b9/icons/kit/custom';
import type {NumberDecrementStepperProps} from '@chakra-ui/react';
import {forwardRef, NumberDecrementStepper as ChakraNumberDecrementStepper} from '@chakra-ui/react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

export const NumberDecrementStepper = forwardRef<NumberDecrementStepperProps, 'div'>(({children, ...rest}, ref) => (
  <ChakraNumberDecrementStepper {...rest} ref={ref}>
    {children || <FontAwesomeIcon icon={faCaretDown} />}
  </ChakraNumberDecrementStepper>
));
